import paths from '~/pages/paths';

export const fallbackNavigation = {
  navigation: {
    steps: [
      {
        key: 'services',
        pathKey: 'services',
        payloadKey: 'services',
        stepName: 'services',
        route: paths.ksa.services,
        stageKey: 'ksaServices',
        name: 'Select Products',
        validationFn: 'ksaServices',
        steps: [],
        validationState: 'UNSUBMITTED',
        state: 'VISIBLE',
        customFields: [],
      },
      {
        key: 'initialInformation',
        pathKey: 'initialInformation',
        route: paths.ksa.initialInformation,
        payloadKey: 'initialInformation',
        name: 'Initial Information',
        stepName: 'initialInformation',
        validationFn: 'ksaInitialInformation',
        steps: [],
        validationState: 'UNSUBMITTED',
        state: 'VISIBLE',
      },

      {
        key: 'application',
        name: 'Business Information',
        stageKey: 'ksaApplication',
        route: paths.ksa.application,
        pathKey: 'application',
        stateFn: 'alwaysVisible',
        validationFn: 'ksaApplication',
        skipSelection: 'true',
        steps: [
          {
            key: 'application.companyInformation',
            route: '/ksa/application/businessDetails',
            stageKey: 'ksaApplication',
            name: 'Business Details',
            pathKey: 'businessDetails',
            payloadKey: 'companyInformation',
            stateFn: 'alwaysVisible',
            validationFn: 'ksaCompanyInformation',
            dataScope: ['/companyInformation'],
          },
          {
            key: 'application.riskQuestionnaire',
            route: '/ksa/application/riskQuestionnaire',
            stageKey: 'ksaApplication',
            name: 'Risk Questionnaire',
            pathKey: 'riskQuestionnaire',
            payloadKey: 'riskQuestionnaire',
            stateFn: 'alwaysVisible',
            validationFn: 'ksaRiskQuestionnaire',
            dataScope: ['/riskQuestionnaire'],
          },
          {
            key: 'application.managers',
            route: '/ksa/application/businessOwners',
            stageKey: 'ksaApplication',
            name: 'Business Owner',
            pathKey: 'businessOwners',
            payloadKey: 'managers',
            stateFn: 'alwaysVisible',
            validationFn: 'ksaManagers',
            dataScope: ['/managers'],
          },
          {
            key: 'application.bankAccount',
            route: '/ksa/application/bankDetails',
            stageKey: 'ksaApplication',
            name: 'Bank Details',
            payloadKey: 'bankAccount',
            pathKey: 'bankDetails',
            stateFn: 'alwaysVisible',
            validationFn: 'ksaBankAccount',
            dataScope: ['/bankAccount'],
          },
          {
            key: 'application.reviewAndSubmit',
            route: '/ksa/application/reviewAndConfirm',
            stageKey: 'ksaApplication',
            name: 'Review & Confirm',
            pathKey: 'reviewAndConfirm',
            payloadKey: 'reviewAndSubmit',
            stateFn: 'alwaysVisible',
            validationFn: 'ksaReviewAndSubmit',
            dataScope: ['/reviewAndSubmit'],
          },
        ],
      },
      {
        steps: [
          {
            key: 'contract',
            name: 'Agreement',
            stepKey: 'signContract',
            uiKey: 'signContract',
            route: ``,
            validationError: false,
          },
          {
            key: 'contract',
            name: 'Identity Verification',
            stepKey: 'signContract',
            uiKey: 'signContract',
            route: ``,
            validationError: false,
          },
        ],
        key: 'contract',
        name: 'Agreement',
        stepKey: 'signContract',
        uiKey: 'signContract',
        route: ``,
        validationError: false,
      },

      {
        key: 'completion',
        steps: [],
        name: 'Finish',
        stepKey: 'Finish',
        uiKey: 'Finish',
        route: ``,
        validationError: false,
      },
    ],
  },
};
